// extracted by mini-css-extract-plugin
export default {"tableRowV8":"tableV8_tableRow__rCtCT","rowOptionsCell":"RowOptionsCell_rowOptionsCell__lOTC+"};